import * as React from "react";
export function useSelection() {
  const [selection, setSelection] = React.useState<Array<string | number>>([]);

  return { selection, setSelection };
}
